import { AsyncPipe } from '@angular/common'
import { Component, inject, OnDestroy, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { Router } from '@angular/router'
import { AuthHandler } from '@cr-driver/handler/auth.handler'
import { BreadcrumbHandler } from '@cr-driver/handler/breadcrumb.handler'
import { StateHandler } from '@cr-driver/handler/state.handler'
import { DriverStore } from '@cr-driver/stores/driver.store'
import { TranslateModule } from '@ngx-translate/core'
import { PcIconComponent } from '@shared/components/pc-icon/pc-icon.component'

import { Subject, takeUntil } from 'rxjs'

@Component({
  selector: 'app-header',
  imports: [AsyncPipe, MatButtonModule, MatMenuModule, MatIconModule, TranslateModule, PcIconComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  protected stateManager = inject(StateHandler)
  protected driverStore: DriverStore = inject(DriverStore)
  private router: Router = inject(Router)

  breadcrumbHandler = inject(BreadcrumbHandler)
  authHandler = inject(AuthHandler)

  showMenu: boolean
  isOnboarding: boolean = false

  private destroy$ = new Subject<void>()

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.isOnboarding = this.router.url.includes('onboarding')
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  goHome() {
    this.stateManager.goToMainPage()
  }
}
